@let isMdOrAbove = viewportSelectors.isMdAndUp | select;
@let author = selectors.authorFor(catalogRecord) | select;
@let series = selectors.marcDetailsSeriesStringFor(catalogRecord) | select;

<div class="flex flex-row text-wrap gap-3 md:gap-5 items-center md:items-start">
  <!-- Cover Image -->
  <a pxNamedRouterLink="CATALOG_BIB_DETAILS" [pxNamedRouterLinkParams]="{id: catalogRecord.id}">
    <mx-cover-image [catalogRecord]="catalogRecord" [widthRem]="8.75" [heightRem]="isMdOrAbove ? 10.75 : 8" [priority]="true"/>
  </a>

  <!-- Details -->
  <div class="flex flex-col gap-1 py-4 text-body-large">
    <mx-link-button [label]="selectors.titleFor(catalogRecord) | select | format: 'REPLACE_EMPTY'" linkType="inline" [truncateMaxLines]="3"
                    labelClasses="text-headline-small" routeName="CATALOG_BIB_DETAILS" [routeParams]="{id: catalogRecord.id}"/>

    <p>
      by
      @if (author) {
        <mx-link-button [label]="author" linkType="inline" routeName="CATALOG_SEARCH" [queryParams]="{q: author, searchTarget: 'AUTHOR'}"
                        labelClasses="text-title-medium"/>
      } @else {
        <span class="text-title-medium">{{ DEFAULT_EMPTY_VALUE_REPLACEMENT_STRING }}</span>
      }
    </p>

    <p>{{ selectors.materialTypeDescriptionFor(catalogRecord) | select | format: 'REPLACE_EMPTY' }}</p>

    <p>{{ selectors.publicationDateFor(catalogRecord) | select | format: 'REPLACE_EMPTY' }}</p>

    @if (series) {
      <mx-link-button [label]="series" linkType="inline" routeName="CATALOG_SEARCH" [queryParams]="{q: series, searchTarget: 'SERIES'}"
                      labelClasses="text-title-medium"/>
    }
  </div>
</div>
